import { createContext } from 'react';

import {
  AppService,
  AuthService,
  BookingService,
  ManageBookingService,
  ConfigService,
  ConfigModel,
  defaultConfig
} from '@ibe/services';

export const authService = new AuthService();
export const AuthContext = createContext<AuthService>(authService);

export const bookingService = new BookingService();
export const BookingContext = createContext<BookingService>(bookingService);

export const manageBookingService = new ManageBookingService();
export const ManageBookingContext = createContext<ManageBookingService>(manageBookingService);

export const configService = new ConfigService(ConfigModel, defaultConfig);
export const ConfigContext = createContext<ConfigService<ConfigModel>>(configService);

export const appService = new AppService(authService);
export const AppContext = createContext<AppService>(appService);
